import {Theme} from "@mui/material/styles";
import {merge} from "lodash";
import Alert from "./Alert";
import Autocomplete from "./Autocomplete";
import ButtonGroup from "./ButtonGroup";
import Container from "./Container";
import ControlLabel from "./ControlLabel";
import Drawer from "./Drawer";
import Grid from "./Grid";
import Link from "./Link";
import LoadingButton from "./LoadingButton";
import Menu from "./Menu";
import Progress from "./Progress";
import SvgIcon from "./SvgIcon";
import Switch from "./Switch";
import Table from "./Table";
import ToggleButton from "./ToggleButton";
import Tooltip from "./Tooltip";
import Typography from "./Typography";

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme: Theme) {
  return merge(
    Menu(theme),
    Grid(),
    Link(),
    Table(theme),
    Alert(theme),
    Switch(theme),
    Drawer(theme),
    Tooltip(theme),
    SvgIcon(),
    Progress(theme),
    Container(),
    Typography(theme),
    ButtonGroup(theme),
    Autocomplete(theme),
    ControlLabel(theme),
    ToggleButton(),
    LoadingButton(theme)
  );
}
